import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtendimentoRoutingModule } from './atendimento-routing.module';
import { ListaComponent } from './lista/lista.component'
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgSelectModule} from "@ng-select/ng-select";
import {MatTooltip} from "@angular/material/tooltip";
import {NgxPaginationModule} from "ngx-pagination";
import {AgendaModule} from "../../trabalho/agenda/agenda.module";
import { AtendimentoDetalhesPaginaComponent } from './atendimento-detalhes-pagina/atendimento-detalhes-pagina.component';

@NgModule({
  declarations: [
    ListaComponent,
    AtendimentoDetalhesPaginaComponent
  ],
    imports: [
        CommonModule,
        AtendimentoRoutingModule,
        ComponentesModule,
        ReactiveFormsModule,
        NgSelectModule,
        FormsModule,
        MatTooltip,
        NgxPaginationModule,
        AgendaModule
    ]
})
export class AtendimentoModule { }
